document.querySelectorAll('.footer-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
        const content = header.nextElementSibling;
      
         // Toggle the display of the content
        if (content.style.display === 'block') {
            content.style.display = 'none';
            // Remove active class from header and content
            header.classList.remove('active');
            content.classList.remove('active-content');
        } else {
            content.style.display = 'block';
            // Add active class to header and content
            header.classList.add('active');
            content.classList.add('active-content'); 
        }
      
    });
});